import { STATUSES } from '../../constants';

export default function useGetStatus({ myPrizes }) {
  return !!myPrizes?.length ? STATUSES.win : STATUSES.lose;
}
